import { defineComponent as _defineComponent } from 'vue'
import { computed, ref } from "vue";
import Ajax from "@/utils/DuduAjax";
import { showConfirm, showSuccess, showWarning } from "@/utils/UI";
import { API_BIS_PATENT_BATCHCATEGORY } from "@/configs/Apis";
import { useStore } from "@/stores";
import cloneDeep from "lodash/cloneDeep";


export default /*#__PURE__*/_defineComponent({
  __name: 'BatchCategory',
  props: {
  patentIdList: {
    type: Array,
    default: () => [],
    required: true,
  },
},
  emits: ["data-changed"],
  setup(__props, { expose, emit }) {

const props = __props;




const store = useStore();
const projectId = computed(() => {
  const pInfo: any = (store.state as any).project.info || {};
  return pInfo.id || 0;
});

const tree = ref<any>();
const changed = ref(false);
const visible = ref(false);
const loading = ref(false);
const treeProps = { label: "name", children: "children" };

const staticTreeData = computed(() => {
  const categoryTree = cloneDeep((store.state as any).project.customCategoryTree);
  categoryTree.forEach((item: any) => (item.disabled = true));
  return categoryTree;
});

const open = () => {
  visible.value = true;
};

const closeDialog = () => {
  visible.value = false;
  if (changed.value) {
    store.dispatch("project/getCustomCategoryData");
    emit("data-changed");
    changed.value = false;
  }
};

const doCategory = () => {
  if (!props.patentIdList || !props.patentIdList.length) {
    showWarning("请选择专利数据");
    return;
  }
  const selectedNodes = tree.value ? tree.value.getCheckedNodes() : [];
  if (!selectedNodes || !selectedNodes.length) {
    showWarning("请选择一个分类");
    return;
  }
  showConfirm("是否批量分类").then(async () => {
    try {
      loading.value = true;
      const categoryIdList: Array<any> = selectedNodes.map((node: any) => node.id);
      await Ajax.post(
        { url: API_BIS_PATENT_BATCHCATEGORY, path: { projectId: projectId.value } },
        { patentIdList: props.patentIdList, categoryIdList }
      );
      showSuccess("分类成功");
      changed.value = true;
      closeDialog();
    } finally {
      loading.value = false;
    }
  });
};

expose({ open });

return { __sfc: true,props, emit, store, projectId, tree, changed, visible, loading, treeProps, staticTreeData, open, closeDialog, doCategory }
}

})